<template>
  <div v-if="assetStore.sortedAssets.length > 0">
    <label class="dropdown-label" for="asset-dropdown">Asset</label>
    <Select
      inputId="asset-dropdown"
      v-model="selectedAssetId"
      :options="assetOptions"
      optionLabel="label"
      optionValue="value"
      placeholder="Select an asset"
      :filter="true"
      :filterFields="['label', 'addressString']"
      filterPlaceholder="Search by site or address"
      fluid
    />
    <small class="text-muted mt-1 d-flex align-items-center">
      <span
        class="mr-1 flex-shrink-0 AssetSelector-status-dot"
        :class="{ 'is-active': assetStore.isDistanceSorted }"
      ></span>
      <span>{{ statusText }}</span>
    </small>
  </div>
  <div v-else>
    <div class="alert alert-warning">No assets found</div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import Select from 'primevue/select';

import { useStore as useAssetStore } from '@/stores/asset';
import { useStore as useWizardStore } from '@/stores/wizard';

const assetStore = useAssetStore();
const wizardStore = useWizardStore();

const statusText = computed(() => {
  if (assetStore.locationStatus === 'loading') return 'Locating…';
  if (assetStore.isDistanceSorted) return 'Sorted by distance';
  if (assetStore.locationStatus === 'ok') {
    return 'Sorted alphabetically (no asset coordinates)';
  }
  return 'Sorted alphabetically (GPS unavailable)';
});

const selectedAssetId = computed({
  get: () => wizardStore.assetId,
  set: (id: string) => {
    wizardStore.assetId = id;
    wizardStore.accountId = '';
  }
});

const assetOptions = computed(() => {
  return assetStore.sortedAssets.map((asset) => ({
    value: asset._id,
    label:
      asset.distance != null
        ? `${asset.siteName} [${asset.distance.toFixed(1)} mi]`
        : asset.siteName,
    addressString: asset.addressString
  }));
});
</script>
<style>
.AssetSelector-status-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: #9aa1a8;
}
.AssetSelector-status-dot.is-active {
  background-color: var(--etn-c-primary);
}
</style>
